<div class="container">
  <mat-toolbar class="toolbar">
    <button mat-icon-button (click)="snav.toggle()">
      <mat-icon>menu</mat-icon>
    </button>
    <h1>Tumsa Reclutamiento</h1>
  </mat-toolbar>

  <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
    <mat-sidenav #snav opened="true" [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <div class="sidenav">


        <mat-accordion class="sideitem" *ngFor="let section of sections let i = index">
          <mat-expansion-panel style="background-color: rgb(31, 33, 49);" hideToggle>
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{section.name}}
              </mat-panel-title>
              <mat-panel-description>
                {{section.progress}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <p>{{section.description}}</p>
            <button [disabled]="i>0" mat-stroked-button class="exambutton" (click)="onSelect(section)">
              <div matRipple [matRippleRadius]="200" [matRippleColor]="'rgb(255, 87, 118, 0.8)'"
                [matRippleUnbounded]="false">Seleccionar Prueba</div>
            </button>
          </mat-expansion-panel>
        </mat-accordion>


        <div (click)="openDialog()"
          class="sendbutton mat-elevation-z4" matRipple [matRippleRadius]="300"
          [matRippleColor]="'rgb(255, 87, 118, 0.3)'">
          <span class="buttontext">Salir</span>

        </div>




      </div>
    </mat-sidenav>

    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>